const memoryStorage = new Map<string, string>();
const FALLBACK_PREFIX = "immigrant-defense-fallback:";

export function readStoredValue(key: string): string | null {
  const memoryValue = memoryStorage.get(key);
  if (memoryValue !== undefined) return memoryValue;

  const session = accessStorage(() => window.sessionStorage);
  if (session && safeGet(session, `${FALLBACK_PREFIX}${key}`) === "1") {
    return safeGet(session, key);
  }

  const localValue = safeGet(accessStorage(() => window.localStorage), key);
  if (localValue !== null) return localValue;
  return safeGet(session, key);
}

export function writeStoredValue(key: string, value: string): boolean {
  const local = accessStorage(() => window.localStorage);
  if (safeSet(local, key, value)) {
    const session = accessStorage(() => window.sessionStorage);
    safeRemove(session, key);
    safeRemove(session, `${FALLBACK_PREFIX}${key}`);
    memoryStorage.delete(key);
    return true;
  }

  const session = accessStorage(() => window.sessionStorage);
  if (safeSet(session, key, value) && safeSet(session, `${FALLBACK_PREFIX}${key}`, "1")) {
    memoryStorage.delete(key);
    return true;
  }

  memoryStorage.set(key, value);
  return false;
}

export function removeStoredValue(key: string): void {
  const local = accessStorage(() => window.localStorage);
  const session = accessStorage(() => window.sessionStorage);
  safeRemove(local, key);
  safeRemove(session, key);
  safeRemove(session, `${FALLBACK_PREFIX}${key}`);
  memoryStorage.delete(key);
}

export function readStoredNumber(key: string): number {
  const value = Number(readStoredValue(key));
  return Number.isFinite(value) && value >= 0 ? value : 0;
}

function accessStorage(accessor: () => Storage): Storage | null {
  try {
    return accessor();
  } catch {
    return null;
  }
}

function safeGet(storage: Storage | null, key: string): string | null {
  try {
    return storage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function safeSet(storage: Storage | null, key: string, value: string): boolean {
  try {
    storage?.setItem(key, value);
    return storage !== null;
  } catch {
    return false;
  }
}

function safeRemove(storage: Storage | null, key: string): void {
  try {
    storage?.removeItem(key);
  } catch {
    return;
  }
}
